import React, { useMemo, forwardRef } from 'react'
import styled from 'styled-components'
import { useLayoutContext } from './LayoutContext'
import { TColProps, TAutoLayout } from './types'
import { MAXIMUM_COL } from './constants'
import { renderCssStringOfCol } from './helper'

export interface IColProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
    xs?: number | TColProps | TAutoLayout
    sm?: number | TColProps | TAutoLayout
    md?: number | TColProps | TAutoLayout
    lg?: number | TColProps | TAutoLayout
    xl?: number | TColProps | TAutoLayout
    vnw?: number | TColProps | TAutoLayout
    children: React.ReactNode
}

const Container = styled.div<{ cssString: string }>`
    ${({ cssString }) => cssString}
`

const Col = forwardRef<HTMLDivElement, IColProps>(
    ({ xs = MAXIMUM_COL, sm, md, lg, xl, vnw, children, ...restProps }, ref) => {
        const { gutter } = useLayoutContext()
        const cssString = useMemo(
            () => renderCssStringOfCol({ xs, sm, md, lg, xl, vnw }, gutter),
            [gutter, lg, md, sm, xl, xs, vnw]
        )
        return (
            <Container cssString={cssString} id='vnwLayout__col' ref={ref} {...restProps}>
                {children}
            </Container>
        )
    }
)

export default Col
